import type { ReactNode } from "react";

import { MenuItem } from "@skilitics/designer-ui-components";

import type { DesignerNode } from "../../../types";
import { useSaveTemplate } from "../../templates";

interface Props {
  node: DesignerNode;
  children: ReactNode;
}

export const SaveTemplateMenuItem = ({ node, children }: Props) => {
  const saveTemplate = useSaveTemplate();
  const handleSaveTemplate = () => saveTemplate({ nodeId: node.id });

  return <MenuItem onClick={handleSaveTemplate}>{children}</MenuItem>;
};
